export default [
  {
    path: 'overview',
    name: 'Overview',
    redirect : 'readme',
    component: () => import(/* webpackChunkName: "fenceline-overview" */ '../views/Overview.vue'),
  },
  {
    path: 'readme',
    name: 'Readme',
    component: () => import(/* webpackChunkName: "fenceline-overview" */ '../views/Readme.vue'),
  },
]
